import { Alert, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const StyledAlert = styled(Alert)(() => ({
  borderRadius: 1,
}));

export const MergePatientsModalInfo = () => {
  return (
    <StyledAlert severity="warning">
      <Typography fontWeight="bold">Note</Typography>
      <Typography>Once merged, the secondary profile cannot be recovered.</Typography>
    </StyledAlert>
  );
};
